<page-load-header *ngIf="!initialized"></page-load-header>

<assessment-result-details [isShared]="true"></assessment-result-details>


